/**
 * BNova Business Dashboard Routes
 * Connected to BNova backend (PostgreSQL/Prisma) + AI-services (Qdrant).
 * Removed legacy Creative Tim demo pages (Billing, RTL, Notifications, Tables).
 */

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Logout from "layouts/authentication/logout";
import UserAnalytics from "layouts/user-analytics";
import UserManagement from "layouts/user-management";
import UploadLibrary from "layouts/upload-library";
import StudentAnalytics from "layouts/student-analytics";
import ApiManagement from "layouts/api-management";
import SSODomains from "layouts/sso-domains";
import VectorSearch from "layouts/vector-search";
import Profile from "layouts/profile";

// @mui icons
import Icon from "@mui/material/Icon";

// requiresSuper: true = only visible when user has "super" role
// Default role sees only Upload Library and Logout
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "User Analytics",
    key: "user-analytics",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/user-analytics",
    component: <UserAnalytics />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "User Management",
    key: "user-management",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/user-management",
    component: <UserManagement />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "Student Analytics",
    key: "student-analytics",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/student-analytics",
    component: <StudentAnalytics />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "Vector Search",
    key: "vector-search",
    icon: <Icon fontSize="small">manage_search</Icon>,
    route: "/vector-search",
    component: <VectorSearch />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "API Management",
    key: "api-management",
    icon: <Icon fontSize="small">api</Icon>,
    route: "/api-management",
    component: <ApiManagement />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "SSO Domains",
    key: "sso-domains",
    icon: <Icon fontSize="small">domain</Icon>,
    route: "/sso-domains",
    component: <SSODomains />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "Upload Library",
    key: "upload-library",
    icon: <Icon fontSize="small">library_books</Icon>,
    route: "/upload-library",
    component: <UploadLibrary />,
    requiresSuper: false,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">account_circle</Icon>,
    route: "/profile",
    component: <Profile />,
    requiresSuper: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    authPage: true,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
    authPage: true,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "logout",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/logout",
    component: <Logout />,
    requiresSuper: false,
  },
];

export default routes;
